const PENDING = 'pending';
const CONFIRMED = 'confirmed';
const CANCELLED = 'cancelled';
const COMPLETED = 'completed';
const PENDING_USER_ALT_CONFIRM = 'pending_user_alt_confirm';
const PENDING_ALT = 'pending_alternatives';

export const BookingStatus = {
  PENDING,
  PENDING_ALT,
  PENDING_USER_ALT_CONFIRM,
  CONFIRMED,
  COMPLETED,
  CANCELLED,
};
